import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import moment from "moment"
import VueScrollReveal from 'vue-scroll-reveal'
import {store} from './vuex/store.js'
import VuePageTransition from 'vue-page-transition'
import i18n from './i18n'
import { pwaService } from './services/pwa.service'
import { notificationService } from './services/notification.service'
import toastService from './services/toast.service'

// Using ScrollReveal's default configuration
Vue.use(VueScrollReveal);
Vue.use(VuePageTransition)

// OR specifying custom default options for all uses of the directive
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 1050,
  scale: 1,
  distance: '18px',
  mobile: true,
  origin: 'left',
  viewFactor: '0.3'
});
moment.locale(i18n.locale)

Vue.config.productionTip = false

// Make PWA, notification, and toast services available globally
Vue.prototype.$pwa = pwaService
Vue.prototype.$notifications = notificationService
Vue.prototype.$toast = toastService

// Initialize PWA state in Vuex using mutations for proper reactivity
store.commit('SET_PWA_INSTALLED', pwaService.isRunningAsPWA())
store.commit('SET_PWA_ONLINE', navigator.onLine)

// Listen for PWA events and update store via mutations
pwaService.on('installable', () => {
  console.log('[Main] PWA installable event - updating store')
  store.commit('SET_PWA_CAN_INSTALL', true)
})

pwaService.on('installed', () => {
  console.log('[Main] PWA installed event - updating store')
  store.commit('SET_PWA_INSTALLED', true)
})

pwaService.on('updateAvailable', () => {
  console.log('[Main] PWA update available - updating store')
  store.commit('SET_PWA_UPDATE_AVAILABLE', true)
})

pwaService.on('online', () => {
  store.commit('SET_PWA_ONLINE', true)
})

pwaService.on('offline', () => {
  store.commit('SET_PWA_ONLINE', false)
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
